/**
 * Internal dependencies
 */
import {
  SET_ATTACHMENT_INITIALIZE,
  SET_ATTACHMENT_LIST,
  CLEAR_ATTACHMENT_LIST
} from '@naruto/bgdcms/src/reducers/cores/attachment/actions';
import { errorCatch } from '@naruto/bgdcms/src/reducers/_Capture/errorCapture';
import { Dispatch, ThunkAction, Models, MiddleWare, Attachments } from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postAttachmentInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_ATTACHMENT_INITIALIZE());
  };

/* Attachment */
/**
 * 上傳附件
 */
export const postAttachment =
  (files: FileList): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const newFormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      newFormData.append('files', files[i]);
    }
    const result = await api.attachment.postAttachment<Attachments, FormData>(newFormData);
    if (!result.error && result.response) {
      dispatch(SET_ATTACHMENT_LIST({ list: result.response }));
    } else {
      const oldState = getState().attachment.attachmentList;
      dispatch(SET_ATTACHMENT_LIST({ list: { ...oldState } }));
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 清除附件
 */
export const clearAttachmentList =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(CLEAR_ATTACHMENT_LIST());
  };
